import { SafetyLocalStorage } from '@mail-core/std';
import { Button } from '@vkontakte/vkui';
import familySettingsStackImg from 'img/tooltip/family-settings.png';
import React, { forwardRef, useCallback, useEffect } from 'react';
import { USER_EMAIL } from 'reactApp/appHelpers/configHelpers';
import { getIdByStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

import styles from './FamilySettingsStackTooltip.css';

interface FamilySettingsStackTooltipProps {
    onClose?: () => void;
    onShow?: () => void;
    onClick?: () => void;
    onCrossClose?: () => void;
    leftOffset?: number;
    placement?: ETooltipPlacement;
    closeOnOutsideClick?: boolean;
    targetSelector?: string;
}

const TOOLTIP_CLOSED_KEY = 'family_settings_stack_tooltip_closed';

const email = USER_EMAIL;
const lStorage = new SafetyLocalStorage({});

export const FamilySettingsStackTooltip = forwardRef<HTMLDivElement, FamilySettingsStackTooltipProps>(
    ({
        onClose,
        onShow,
        onClick,
        onCrossClose,
        leftOffset,
        placement = ETooltipPlacement.bottomEnd,
        closeOnOutsideClick = true,
        targetSelector = '[data-qa-id="family-settings-stack"]',
    }) => {
        useEffect(() => {
            sendDwh({
                eventCategory: ECategoryGa.tooltip,
                action: 'show',
                dwh_enabled: true,
                dwhData: { name: 'manage_family_aon' },
            });
            onShow?.();
        }, [onShow]);

        const handleAddClick = useCallback(() => {
            sendDwh({
                eventCategory: ECategoryGa.tooltip,
                action: 'click',
                dwh_enabled: true,
                dwhData: { name: 'manage_family_aon' },
            });
            onClick?.();
            lStorage.setItem(`${email}|${TOOLTIP_CLOSED_KEY}`, 'true');
            const url = getIdByStorage(EStorageType.family);
            if (typeof window !== 'undefined' && window.location) {
                window.location.assign(url);
            }
        }, [onClick]);

        const handleCrossClose = useCallback(() => {
            lStorage.setItem(`${email}|${TOOLTIP_CLOSED_KEY}`, 'true');
            onCrossClose?.();
        }, [onCrossClose]);

        const handleClose = useCallback(() => {
            sendDwh({
                eventCategory: ECategoryGa.tooltip,
                action: 'close',
                dwh_enabled: true,
                dwhData: { name: 'manage_family_aon' },
            });
            onClose?.();
        }, [onClose]);

        const targetRef = document.querySelector(targetSelector) as HTMLDivElement;

        return (
            <FloatingTooltip
                target={targetRef}
                placement={placement}
                size={ETooltipSize.fit}
                onClose={handleClose}
                onShow={onShow}
                onCrossClose={handleCrossClose}
                usePortal
                qaId="family-settings-stack-tooltip"
                leftOffset={leftOffset}
                closeOnOutsideClick={closeOnOutsideClick}
            >
                <div className={styles.root}>
                    <div className={styles.textBlock}>
                        <div className={styles.title}>Тут можно добавлять и удалять участников подписки</div>
                        <div className={styles.text}>И видеть, сколько ГБ каждый занимает в Облаке семьи</div>
                    </div>
                    <Button onClick={handleAddClick} className={styles.button} size="l" stretched={false}>
                        Хорошо
                    </Button>
                    <img className={styles.image} src={familySettingsStackImg} alt="Семья" />
                </div>
            </FloatingTooltip>
        );
    }
);

FamilySettingsStackTooltip.displayName = 'FamilySettingsStackTooltip';
